import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface CommissionBreakdownProps {
  spreadCommission?: string;
  lotCommission?: string;
  cpaCommission?: string;
  rebateCommission?: string;
}

const CommissionBreakdown = ({
  spreadCommission = '$0.00',
  lotCommission = '$0.00',
  cpaCommission = '$0.00',
  rebateCommission = '$0.00',
}: CommissionBreakdownProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Commission Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-sm">Spread Commission</span>
            <span className="font-bold">{spreadCommission}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">Lot Commission</span>
            <span className="font-bold">{lotCommission}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">CPA Commission</span>
            <span className="font-bold">{cpaCommission}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm">Rebate Commission</span>
            <span className="font-bold">{rebateCommission}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CommissionBreakdown;
